import React from "react";
import filterIcon from "../img/filter_icon.svg";
import FilterButton from "./FilterButton";
import { getFilterName } from "./helper";
export default function Filter({
  onFilterClick,
  filters,
  removeItemFromFilter,
}) {
  return (
    <div className="filter mt1">
      <img
        src={filterIcon}
        className="filter_icon mouse"
        alt="Lukk"
        onClick={onFilterClick}
      />
      <div className="filter_btns scrolling-wrapper-flexbox">
        {filters.map(function (item) {
          return (
            <FilterButton
              title={getFilterName(item)}
              key={`fb${item}`}
              id={`${item}`}
              removeItemFromFilter={removeItemFromFilter}
            />
          );
        })}
        {filters.length === 0 && (
          <div className="addfilters">Legg til filter</div>
        )}
      </div>
    </div>
  );
}
